import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ['mobileBtn', 'closeBtn', 'menu', 'dropdownToggle', 'searchBar', 'searchIcon', 'search', 'userDropdownToggle', 'userDropdown']

    connect() {
        if (this.hasSearchBarTarget) {
            this.searchBarTarget.style.display = 'none';
            this.searchIconTarget.style.backgroundColor = '#E2D6E4';
        }

        this.element.querySelectorAll('.dropdown-content').forEach(dropdown => {
            dropdown.classList.add('hidden');
        });

        this.element.querySelectorAll('.dropdown-toggle svg').forEach(arrow => {
            arrow.style.transform = 'rotate(0deg)';
        });

    }

    closeMobileDropdowns(exceptContent = null) {
        this.element.querySelectorAll('.mobile-menu-item .dropdown-content').forEach(content => {
            if (content !== exceptContent) content.classList.add('hidden');
        });
    }

    resetMobileDropdownArrows(exceptArrow = null) {
        this.element.querySelectorAll('.mobile-menu-item .dropdown-toggle svg').forEach(svg => {
            if (svg !== exceptArrow) svg.style.transform = 'rotate(0deg)';
        });
    }

    closeUserDropdown() {
        if (this.hasUserDropdownTarget) {
            this.userDropdownTarget.classList.add('hidden');
        }
        if (this.hasUserDropdownToggleTarget) {
            this.userDropdownToggleTarget.setAttribute('aria-expanded', 'false');
            const userArrow = this.userDropdownToggleTarget.querySelector('svg');
            if (userArrow) userArrow.style.transform = 'rotate(0deg)';
        }
    }

    ensureHeaderZIndex() {
        const currentZIndex = window.getComputedStyle(this.element).zIndex;
        if (currentZIndex === 'auto' || parseInt(currentZIndex) < 50) {
            this.element.style.zIndex = '60';
        }
    }

    resetHeaderZIndex() {
        if (this.hasSearchBarTarget && this.searchBarTarget.style.display !== 'none') {
            return;
        }
        
        if (!this.hasMenuTarget || this.menuTarget.classList.contains('hidden')) {
            this.element.style.zIndex = '';
        }
    }

    toggleSearchBar(e) {
        if (!this.hasSearchBarTarget || !this.hasSearchIconTarget) return;
        
        const isHidden = this.searchBarTarget.style.display === 'none';
        this.searchBarTarget.style.display = isHidden ? 'block' : 'none';
        
        if (isHidden) {
            this.ensureHeaderZIndex();
        } else {
            this.resetHeaderZIndex();
        }
        
        const searchIconContainer = this.searchIconTarget;
        
        const searchIcon = searchIconContainer.querySelector('.search-icon');
        const closeIcon = searchIconContainer.querySelector('.close-icon');
        
        if (isHidden) {
            searchIconContainer.style.backgroundColor = '#541E63';
            searchIcon.classList.add('hidden');
            closeIcon.classList.remove('hidden');
            closeIcon.querySelector('svg').style.color = 'white';
            searchIconContainer.style.top = '0';
            searchIconContainer.style.height = '70px';
            closeIcon.style.paddingBottom = '15px';


        } else {
            searchIconContainer.style.backgroundColor = '#E2D6E4';
            searchIcon.classList.remove('hidden');
            closeIcon.classList.add('hidden');
            searchIconContainer.style.height = '48px'
        }
    }

    toggleMenu() {
        if (window.innerWidth < 1024 && this.hasSearchBarTarget && this.hasSearchIconTarget) {
            this.searchBarTarget.style.display = 'none';
            
            const searchIconContainer = this.searchIconTarget;
            const searchIcon = searchIconContainer.querySelector('.search-icon');
            const closeIcon = searchIconContainer.querySelector('.close-icon');
            
            searchIconContainer.style.backgroundColor = '#E2D6E4';
            searchIcon.classList.remove('hidden');
            closeIcon.classList.add('hidden');
            searchIconContainer.style.height = '48px';
        }

        this.element.querySelectorAll('.dropdown-content').forEach(dropdown => {
            dropdown.classList.add('hidden');
        });
    
        this.element.querySelectorAll('.dropdown-toggle svg').forEach(arrow => {
            arrow.style.transform = 'rotate(0deg)';
        });
    
        const isHidden = this.menuTarget.classList.contains('hidden');
        
        if (!isHidden) {
            this.menuTarget.style.zIndex = '';
            this.menuTarget.style.display = '';
            this.menuTarget.style.visibility = '';
            this.menuTarget.style.opacity = '';
            this.element.style.zIndex = '';
            if (this.hasMobileBtnTarget) {
                this.mobileBtnTarget.style.display = '';
                this.mobileBtnTarget.style.visibility = 'visible';
            }
        } else {
            this.element.style.zIndex = '100000';
            this.menuTarget.style.zIndex = '100001';
            this.menuTarget.style.display = 'block';
            this.menuTarget.style.visibility = 'visible';
            this.menuTarget.style.opacity = '1';
            if (this.hasMobileBtnTarget) {
                this.mobileBtnTarget.style.display = 'block';
                this.mobileBtnTarget.style.visibility = 'visible';
            }
        }
        
        this.menuTarget.classList.toggle('hidden');
    
        document.body.style.overflow = isHidden ? 'hidden' : 'auto';
        
        const backToTopContainer = document.getElementById('back-to-top-container');
        if (backToTopContainer) {
            backToTopContainer.classList.toggle('hidden', isHidden);
        }
    }

    toggleDropdown(event) {
        event.preventDefault();
        event.stopPropagation();
            
        const toggle = event.currentTarget;
        const menuItem = toggle.closest('.mobile-menu-item');
        if (!menuItem) return;

        const dropdownContent = menuItem.querySelector('.dropdown-content');
        const arrow = toggle.querySelector('svg');
            
        if (!dropdownContent || !arrow) return;

        const willOpen = dropdownContent.classList.contains('hidden');
        if (willOpen) {
            this.closeMobileDropdowns(dropdownContent);
            this.resetMobileDropdownArrows(arrow);
            this.closeUserDropdown();
        }

        dropdownContent.classList.toggle('hidden');
        arrow.style.transform = dropdownContent.classList.contains('hidden')
            ? 'rotate(0deg)'
            : 'rotate(180deg)';
    }

    toggleSearch() {
        if (this.hasSearchTarget) {
            const isHidden = this.searchTarget.classList.contains('hidden');
            this.searchTarget.classList.toggle('hidden');
            document.body.style.overflow = isHidden ? 'hidden' : 'auto';
        }
    }

    toggleUserDropdown(event) {
        event.preventDefault();
        event.stopPropagation();
        
        if (!this.hasUserDropdownTarget || !this.hasUserDropdownToggleTarget) return;
        
        const dropdown = this.userDropdownTarget;
        const toggle = this.userDropdownToggleTarget;
        const arrow = toggle.querySelector('svg');
        
        const isHidden = dropdown.classList.contains('hidden');

        if (isHidden) {
            this.closeMobileDropdowns();
            this.resetMobileDropdownArrows();
        }

        dropdown.classList.toggle('hidden');
        
        if (arrow) {
            arrow.style.transform = isHidden ? 'rotate(180deg)' : 'rotate(0deg)';
        }
        
        toggle.setAttribute('aria-expanded', isHidden ? 'true' : 'false');
    }

    handleUserDropdownKeydown(event) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.toggleUserDropdown(event);
        }
    }

    closeMenuOnLinkClick(event) {
        if (this.hasMenuTarget && !this.menuTarget.classList.contains('hidden') && window.innerWidth < 1024) {
            this.toggleMenu();
        }
    }

}          